import React from 'react';
import { Layout } from 'antd';

export default function FooterView() {
    return (
        <Layout.Footer
            style={{
                textAlign: 'center',
            }}
        >
            Ant Design ©2023 Created by Ant UED
        </Layout.Footer>
    )
}
